import React, { useEffect, useState } from 'react';
import './Stakes.scss';
import { connect } from 'react-redux';
import {
  getStakesActionRequest,
  filterStakesAction,
  sortStakesAction,
  updateQuickFilterAction
} from '../../store/stake/stakeActions';
import MercurXStakeTable 
from '../../components/MercurXStakeTable/MercurXStakeTable';
import MercurXDateRangePicker
from '../../components/MercurXDateRangePicker/MercurXDateRangePicker';
import { Col, Form, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { stakesQuickFilterConstants } from './stakesConstants';


function Stakes({ ...props }) {
  const {
    getStakesRequest,
    stakes,
    quickFilter,
    updateQuickFilter,
    sortStakes,
    filterStakes,
  } = props;

  const [filterInput, setFilterInput] = useState('');
  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

  useEffect(() => {
    getStakesRequest();
    updateQuickFilter(stakesQuickFilterConstants.ALL)
  }, []);
  useEffect(() => {
    filterStakes({
      search: filterInput,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    sortStakes();
  }, [quickFilter]);

  useEffect(() => {
    filterStakes({
      search: filterInput,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    sortStakes();
  }, [filterInput, dateRange])

  useEffect(() => {
    filterStakes({
      search: filterInput,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    sortStakes();
  }, [stakes]);

  return (
    <>
      <div className="text-fs-head-md mb-4">Stakes</div>
      <div className="stakes-filter-panel mt-4">
        <div className="filter-panel-title">Filters</div>
        <Row className="g-3 align-items-end">
          <Col lg={8}>
            <Form.Label className="filter-control-label">Text Search</Form.Label>
            <Form.Control
              className="text-fs-body-sm filter-control-input"
              type="text"
              placeholder="Search by token symbol, address or txn hash..."
              aria-label="Stake text search"
              aria-describedby="basic-addon1"
              value={filterInput}
              onChange={(e) => setFilterInput(e.target.value)}
              size={'sm'}
            />
          </Col>
          <Col lg={4}>
            <MercurXDateRangePicker
              label="Stake Start Range"
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
              onChange={setDateRange}
            />
          </Col>
        </Row>
      </div>
      <Row
        id="stakes-container"
        className="d-flex align-items-center justify-content-end mt-4"
      >
        <Col className="text-md-end">
        <ToggleButtonGroup size={'sm'} type="radio" name="options" defaultValue={1}>
        <ToggleButton
              size={'sm'}
              variant={quickFilter === stakesQuickFilterConstants.ALL ? 'primary' : 'light'}
              className={
                quickFilter !== stakesQuickFilterConstants.ALL ? 'text-t-body-color' : ''
              }
              id="tbg-radio-1"
              value={stakesQuickFilterConstants.ALL}
              onClick={() => updateQuickFilter(stakesQuickFilterConstants.ALL)}
            >
              All
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === stakesQuickFilterConstants.STAKED ? 'primary' : 'light'}
              className={
                quickFilter !== stakesQuickFilterConstants.STAKED ? 'text-t-body-color' : ''
              }
              id="tbg-radio-2"
              value={stakesQuickFilterConstants.STAKED}
              onClick={() => updateQuickFilter(stakesQuickFilterConstants.STAKED)}
            >
              Staked
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === stakesQuickFilterConstants.DONE ? 'primary' : 'light'}
              className={
                quickFilter !== stakesQuickFilterConstants.DONE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-4"
              value={stakesQuickFilterConstants.DONE}
              onClick={() => updateQuickFilter(stakesQuickFilterConstants.DONE)}
            >
              Done
            </ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>
      <div id="stakes-container">
        <MercurXStakeTable />
      </div>
      
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    stakes: state.stakeReducer.stakes,
    quickFilter: state.stakeReducer.quickFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getStakesRequest: (payload) => {
      dispatch(getStakesActionRequest(payload));
    },
    updateQuickFilter: (payload) => {
      dispatch(updateQuickFilterAction(payload));
    },
    sortStakes: (payload) => {
      dispatch(sortStakesAction(payload));
    },
    filterStakes: (payload) => {
      dispatch(filterStakesAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Stakes);
